import React from 'react';
import "./BestOffer.css";
import discount1 from "../images/png/image77.png"
import discount2 from "../images/png/image771.png"
import discount3 from "../images/png/image772.png"

import off1 from '../images/png/Images50-removebg-preview 2.png'

const BestOffer=()=>{
  return (
    <div>
      <div className='bestoffer'>
        <div className='offers'>
          <h1>Best Offers</h1>
          <p>Discover the best offers on our services</p>
        </div>
        <div className='bestwedding'>
          <div className='discount1'>
            <div className='disimg'style={{ backgroundImage: `url(${discount1})`,backgroundRepeat:"no-repeat" }}>
              <div className='packages'>
                <h1>Wedding</h1>
                <h1>Packages</h1>
              </div>
              <div className='off'>
                <h2>Discount</h2>
                <img src={off1} alt="err"/>
                
              </div>
              
            </div>
            <div className='Book'>
              <h1>BOOK NOW</h1>
              
            </div>
            
          </div>
          <h1 className='line'></h1>
          <div className='discount1'>
            <div className='disimg'style={{ backgroundImage: `url(${discount2})`,backgroundRepeat:"no-repeat" }}>
              <div className='packages'>
                <h1>Website</h1>
                <h1>Design</h1>
              </div>
              <div className='off'>
                <h2>Discount</h2>
                <img src={off1} alt="err"/>
                
              </div>
              
            </div>
            <div className='Book'>
              <h1>BOOK NOW</h1>
              
            </div>
            
          </div>
          <h1 className='line'></h1>
          <div className='discount1'>
            <div className='disimg'style={{ backgroundImage: `url(${discount3})`,backgroundRepeat:"no-repeat" }}>
              <div className='packages'>
                <h1>Beach</h1>
                <h1>Photography</h1>
              </div>
              <div className='off'>
                <h2>Discount</h2>
                <img src={off1} alt="err"/>
                
              </div>
              
            </div>
            <div className='Book'>
              <h1>BOOK NOW</h1>
              
            </div>
            
          </div>
          <h1 className='line'></h1>
          <div className='discount1'>
            <div className='disimg'style={{ backgroundImage: `url(${discount1})`,backgroundRepeat:"no-repeat" }}>
              <div className='packages'>
                <h1>Wedding</h1>
                <h1>Packages</h1>
              </div>
              <div className='off'>
                <h2>Discount</h2>
                <img src={off1} alt="err"/>
                
              </div>
              
            </div>
            <div className='Book'>
              <h1>BOOK NOW</h1>
              
            </div>
            
          </div>
          
        </div>
        
      </div>

    </div>
  )
}
export {BestOffer}
